const SCRIPT_SRCS = [
  '/assets/vendors/jquery/jquery-3.6.0.min.js',
  '/assets/vendors/bootstrap/js/bootstrap.bundle.min.js',
  '/assets/vendors/jarallax/jarallax.min.js',
  '/assets/vendors/jquery-ajaxchimp/jquery.ajaxchimp.min.js',
  '/assets/vendors/jquery-appear/jquery.appear.min.js',
  '/assets/vendors/jquery-circle-progress/jquery.circle-progress.min.js',
  '/assets/vendors/jquery-magnific-popup/jquery.magnific-popup.min.js',
  '/assets/vendors/jquery-validate/jquery.validate.min.js',
  '/assets/vendors/nouislider/nouislider.min.js',
  '/assets/vendors/odometer/odometer.min.js',
  '/assets/vendors/swiper/swiper.min.js',
  '/assets/vendors/tiny-slider/tiny-slider.min.js',
  '/assets/vendors/wnumb/wNumb.min.js',
  '/assets/vendors/wow/wow.js',
  '/assets/vendors/isotope/isotope.js',
  '/assets/vendors/countdown/countdown.min.js',
  '/assets/vendors/owl-carousel/owl.carousel.min.js',
  '/assets/vendors/bxslider/jquery.bxslider.min.js',
  '/assets/vendors/bootstrap-select/js/bootstrap-select.min.js',
  '/assets/vendors/vegas/vegas.min.js',
  '/assets/vendors/jquery-ui/jquery-ui.js',
  '/assets/vendors/timepicker/timePicker.js',
  '/assets/vendors/circleType/jquery.circleType.js',
  '/assets/vendors/circleType/jquery.lettering.min.js',
  '/assets/vendors/polyglot-language-switcher/jquery.polyglot.language.switcher.js',
  '/assets/vendors/progress-bar/knob.js',
  '/assets/js/ontech.js',
];

let loadedPromise = null;

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-vendor-src="${src}"]`);
    if (existing) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.vendorSrc = src;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.body.appendChild(script);
  });
}

export function loadVendorScriptsOnce() {
  if (loadedPromise) return loadedPromise;
  loadedPromise = (async () => {
    for (const src of SCRIPT_SRCS) {
      await loadScript(src);
    }
    if (window.jQuery) {
      try {
        window.jQuery(document).trigger('ready');
      } catch (e) {
        // ignore
      }
    }
  })();
  return loadedPromise;
}

function destroyOwlInstance($el) {
  if (!$el.hasClass('owl-loaded')) return;
  try {
    $el.trigger('destroy.owl.carousel');
  } catch (e) {
    // ignore destroy errors and fall through to re-init
  }
}

export function reinitOnRouteChange() {
  if (!window.jQuery) return;
  const $ = window.jQuery;
  try {
    if ($.fn.owlCarousel) {
      $('.thm-owl__carousel').each(function () {
        const $el = $(this);
        const options = $el.data('owl-options') || {};
        destroyOwlInstance($el);
        $el.owlCarousel(options);
      });
    }
    if ($.fn.bxSlider) {
      $('.bx-slider').each(function () {
        const $el = $(this);
        if ($el.hasClass('bxslider-initialized')) return;
        $el.addClass('bxslider-initialized');
        $el.bxSlider();
      });
    }
    if (window.WOW) new window.WOW().init();

    // ── Re-initialize Odometers on Page Load / Route Change ──
    if (window.Odometer) {
      $('.odometer').each(function () {
        const $el = $(this);
        const count = $el.attr('data-count') || '0';
        $el.html('0');
        const odo = new window.Odometer({
          el: $el[0],
          value: 0,
          format: 'd'
        });
        odo.update(parseInt(count, 10));
      });
    }

    // ── Re-initialize Knob Dial Progress Circles ──
    if ($.fn.knob) {
      $('.dial').each(function () {
        const $el = $(this);
        const color = $el.attr("data-fgColor") || '#ffffff';
        const bgColor = $el.attr("data-bgColor") || '#fcbb54';
        const perc = parseInt($el.attr("value") || $el.val() || '0', 10);
        
        $el.knob({
          value: 0,
          min: 0,
          max: 100,
          skin: "tron",
          readOnly: true,
          thickness: 0.07,
          dynamicDraw: true,
          displayInput: false,
          fgColor: color,
          bgColor: bgColor
        });
        
        $({ value: 0 }).animate({ value: perc }, {
          duration: 2000,
          easing: "swing",
          progress: function () {
            $el.val(Math.ceil(this.value)).trigger("change");
          }
        });
      });
    }

    // ── Re-initialize Counter Text Animations ──
    $('.count-text').each(function () {
      const $el = $(this);
      const stop = parseInt($el.attr('data-stop') || '0', 10);
      const speed = parseInt($el.attr('data-speed') || '2000', 10);
      $({ value: 0 }).animate({ value: stop }, {
        duration: speed,
        easing: 'swing',
        step: function () {
          $el.text(Math.ceil(this.value));
        },
        complete: function () {
          $el.text(stop);
        }
      });
    });

  } catch (e) {
    // ignore reinit errors from templates that already self-initialize
  }
}


